// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";
import { AskV2HomeRoutePage, parseAskV2HomeSearch } from "./indexRoute";

/** Same home as `/`, so in-place `/ask-puntt` URLs keep working. */
export const askV2AskHomeRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt",
  validateSearch: parseAskV2HomeSearch,
  component: AskV2HomeRoutePage,
});
